export default function parseAccountInfo(response) {
  return {
    ...response,
    // make date objects from ISO Date strings
    created: Date.parse(response.created),
    lastLogin: Date.parse(response.lastLogin),
    lastUpdated: Date.parse(response.lastUpdated),
    registered: Date.parse(response.registered),
    oldestDataUpdated: Date.parse(response.oldestDataUpdated),
  };
}
